const NAMESPACE = 'DUCKS/TERMS_AND_CONDITIONS';

export default NAMESPACE;
